import { Static, Union } from "runtypes";

import { getNormalEnum } from "../runtypeEnums.js";

import { AnthropicModelLiteral } from "./anthropicTypes.js";
import { KimiModelLiteral } from "./chatCompletionsTypes.js";
import { OpenAiChatModelLiteral } from "./openAiTypes.js";

export const ModelNameLiteral = Union(
  ...AnthropicModelLiteral.alternatives,
  ...OpenAiChatModelLiteral.alternatives,
  ...KimiModelLiteral.alternatives,
);
export type ModelName = Static<typeof ModelNameLiteral>;
export const ModelName = getNormalEnum(ModelNameLiteral);

/**
 * Coerce a persisted thread model value for GraphQL and runtime resolution.
 * Returns null for values that are no longer recognized ModelName enum members.
 */
export function resolvePersistedModelName(
  model: string | null | undefined,
): ModelName | null {
  if (model == null) {
    return null;
  }
  return ModelNameLiteral.guard(model) ? model : null;
}
